import { useAuth } from "@clerk/clerk-react";
import { PrimaryFullScreenSpinner } from "@repo/ui";
import { useNavigate } from "@tanstack/react-router";
import { useTimeout } from "usehooks-ts";

// This function has a delay because tanstack routes are rendered before useAuth is updated with signedIn state
export function RedirectToSignInWithDelay() {
  const auth = useAuth();
  const navigate = useNavigate();

  useTimeout(() => {
    if (!auth.isSignedIn) {
      navigate({ to: "/sign-in", search: { redirect: location.href } });
    }
  }, 100);

  return <PrimaryFullScreenSpinner />;
}
